import { IconStyled, IconStylesProps } from './IconStyles';

export const Warning = ({
  size = 'base',
  className = '',
  fill = 'currentColor',
}: Partial<IconStylesProps>) => (
  <IconStyled
    size={size}
    width={size}
    height={size}
    className={className}
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      xmlns='http://www.w3.org/2000/svg'
      d='M17.7974 15.4692C18.3742 16.594 17.6502 18 16.4981 18H1.5017C0.347415 18 -0.373272 16.5918 0.202415 15.4692L7.70073 0.843223C8.27782 -0.282094 9.72322 -0.280055 10.2993 0.843223L17.7974 15.4692ZM9.00001 12.4453C8.2061 12.4453 7.56251 13.1694 7.56251 14.0625C7.56251 14.9556 8.2061 15.6797 9.00001 15.6797C9.79391 15.6797 10.4375 14.9556 10.4375 14.0625C10.4375 13.1694 9.79391 12.4453 9.00001 12.4453ZM7.63523 6.63237L7.86704 11.4136C7.87788 11.6374 8.04232 11.8125 8.24147 11.8125H9.75854C9.95769 11.8125 10.1221 11.6374 10.133 11.4136L10.3648 6.63237C10.3765 6.3907 10.2055 6.1875 9.99035 6.1875H8.00963C7.79451 6.1875 7.62351 6.3907 7.63523 6.63237Z'
      fill={fill}
    />
  </IconStyled>
);
